<template>
	<header class="header" :class="{ 'whiterBg': type == 2, 'whiterBg sticky' : type == 3 }" id="header">
		<div class="wrap">
			<div class="logo flexBox">
				<router-link :to="{ path: '/' }">
					<span>
						<img v-if="type == 2 || type == 3" src="../assets/logo.png">
						<img v-else src="../assets/logo-white.png">
					</span>
				</router-link>
			</div>
			<ul class="navRig">
				<li class="navBtn" @click="toggleMenu" :class="{ 'active': open }"><span><b></b><b></b><b></b></span></li>
			</ul>
			<div class="navBg" :class="{ 'active': open }"></div>
			<div class="navBox" :class="{ 'active': open }">
				<div class="navTop">
					<div class="navClose" @click="toggleMenu"><span></span><span></span><span></span></div>
				</div>
				<nav class="navList">
					<li :class="routename == 'Home' ? 'active' : ''"><router-link :to="{ path: '/' }">首页</router-link></li>
					<li :class="routename == 'About' ? 'active' : ''">
						<router-link to="/about">关于我们</router-link>
						<transition name="subNav">
							<div class="subNav isshownav">
								<!-- <span @click="changeAboutPage('company')">公司概况</span>
								<span @click="changeAboutPage('history')">历史发展</span>
								<span @click="changeAboutPage('mission')">使命与愿景</span>
								<span @click="changeAboutPage('team')">团队成员</span> -->
								<router-link to="/about?id=company"><span>公司概况</span></router-link>
								<router-link to="/about?id=history"><span>历史发展</span></router-link>
								<router-link to="/about?id=mission"><span>使命与愿景</span></router-link>
								<router-link to="/about?id=team"><span>团队成员</span></router-link>
							</div>
						</transition>
					</li>
					<li :class="routename == 'Service' || routename == 'ServiceDetail' ? 'active' : ''"><router-link to="/service">业务与服务</router-link></li>
					<li :class="routename == 'Case' || routename == 'CaseDetail' ? 'active' : ''"><router-link to="/case">经典案例</router-link></li>
					<!-- <li :class="routename == 'standard' ? 'active' : ''"><router-link to="/standard">收费标准<i></i></router-link></li> -->
					<li :class="routename == 'News' || routename == 'NewsDetail' ? 'active' : ''"><router-link to="/news">新闻资讯</router-link></li>
					<li :class="routename == 'Contact' ? 'active' : ''"><router-link to="/contact">联系我们</router-link></li>
					<li :class="routename == 'Join' ? 'active' : ''"><router-link to="/join">加入我们</router-link></li>
				</nav>
			</div>
			<div class="clear"></div>
		</div>
	</header>
</template>
<script>
export default {
	props: ['type'],
	name: 'Header',
	data() {

		return {
			open: false,
			routename: ""
		}

	},
	mounted() {
		this.routename = this.$route.name;
	},
	methods: {
		toggleMenu() {
			this.open = !this.open;
		},
		// changeAboutPage(id){
		// 	const arg = id;
		// 	this.$emit('childEvent', arg);
		// }
	}
}
</script>
<style lang="scss" scoped>
$mainColor: #C39D6C;

.header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 320px;
    padding: 0;
    z-index: 10;
    box-shadow: none;
    transition: all .3s;
	&.sticky{
		position: sticky;
		position: -webkit-sticky;
	}
}
.logo {
	float: left;
	height: 112px;
	a {
		display: block;
		span {
			display: block;
		}
		img {
			width: auto;
			max-height: 72px;
		}
	}
}
.navRig {
    position: relative;
    float: right;
    line-height: 112px;
    text-align: right;
    font-size: 0;
    margin-left: 2vw;
    transition: all .3s;
	li {
		display: inline-block;
		vertical-align: middle;
		position: relative;
		margin-left: 15px;
		span,
		i {
			display: inline-block;
			vertical-align: middle;
			font-size: 14px;
		}

		span {
			line-height: 40px;
			cursor: pointer;
		}

		i {
			font-style: normal;
		}

		&.navBtn {
			display: none;
			cursor: pointer;
		}
	}
}
.navBtn {
	span {
		width: 25px;
		height: 30px;
		position: relative;
		margin-left: 5px;

		b {
			display: block;
			width: 100%;
			height: 2px;
			background: #FFFFFF;
			position: absolute;
			left: 0;
			top: calc((100% - 4px) / 2);
			transition: all .3s;

			&:nth-child(1) {
				transform: translateY(8px) rotate(0deg);
			}

			&:nth-child(3) {
				transform: translateY(-8px) rotate(0deg);
			}
		}
	}

	.active {
		b {
			&:nth-child(1) {
				transform: translateY(0) rotate(45deg);
			}

			&:nth-child(3) {
				transform: translateY(0) rotate(-45deg);
			}

			&:nth-child(2) {
				opacity: 0;
			}
		}
	}
}

.navBox {
	margin: 0 auto;
    text-align: right;
}

.navList {	
    list-style: none;
    margin: 0;
    font-size: 0;
    text-align: center;
    display: inline-block;
    vertical-align: top;
    transition: all .3s;
	>li {
		position: relative;
		display: inline-block;
		vertical-align: top;
		margin-left: 0.8rem;

		>a {
			position: relative;
			display: block;
			line-height: 112px;
			font-size: 18px;
			color: #FFFFFF;
			font-weight: bold;
			transition: all .3s;
		}

		&:hover {
			> a {
				color: #FFFFFF;
			}
		}
		
		&.active{
			> a{
				color: #FFFFFF;
			}
		}

		&:hover {
			.subNav {
				display: block;
			}
		}
	}

	.subNav {
		position: absolute;
		top: 100%;
		left: 50%;
		min-width: 145px;
		padding: .2rem 0;
		background: #FFFFFF;
		border-top: 4px solid $mainColor;
		overflow: hidden;
		transform: translateX(-50%);
		box-shadow: 0px 13px 15px 0px rgba(0,0,0,0.05);
		display: none;
		>a {
			display: block;
			font-size: 16px;
			color: #666666;
			line-height: 24px;
			text-align: center;
			padding: .1rem 15px;
			transition: all .3s;
			cursor: pointer;
			&:hover {
				background: $mainColor;
				color: #FFFFFF;
			}
		}
	}
}

.whiterBg {
	&.header {
		box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.13);
	}
	.navRig {
		color: #666666;
	}
	.navList{
		> li{
			> a{
				color: #333333;
			}
			
			&:hover {
				> a {
					color: $mainColor;
				}
			}
			&.active{
				> a{
					color: $mainColor;
				}
			}
		}
	}
	.navBtn{
		span{
			b{
				background-color: $mainColor;
			}
		}
	}
}

@media screen and (max-width:1600px) {
	
    .logo{
        height: 80px;
		img{
			height: 54px;
		}
    }
	.navList{
		>li{
			>a{
				font-size: 16px;
				line-height: 80px;
			}
		}
	}
    .navRig{
        line-height: 80px;
		li{
			font-size: 16px;
		}
    }
}

@media screen and (max-width:1200px) {
	.header {
		padding: 0;
		.wrap{
			width: 100%;
		}
	}

	.logo {
		height: 60px;
		a{
			img{
				height: 36px;
			}
		}
	}
	.navRig {
		line-height: 60px;
		margin: 0;
	}

	.navRig li.navBtn {
		display: inline-block;
	}

	.navBg {
		position: fixed;
        left: 0;
		right: 0;
        top: 0;
		width: 100%;
		height: 100vh;
		background: #000000;
		opacity: 0;
		visibility: hidden;
		z-index: 2;
		transition: all .5s;
	}

	.navBox {
		position: fixed;
		right: -66%;
		top: 0;
		height: 100vh;
		width: 66%;
		background: #FFFFFF;
		overflow: hidden;
		z-index: 2;
		transition: all .5s;
	}

	.navTop {
		height: 60px;
		background: $mainColor;
		padding: 0 30px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.navClose {
		width: 25px;
		height: 30px;
		position: relative;
		cursor: pointer;
		margin-right: -10px;
	}

	.navClose span {
		display: block;
		width: 100%;
		height: 2px;
		background: #FFFFFF;
		position: absolute;
		left: 0;
		top: calc((100% - 4px) / 2);
		transition: all .3s;
	}

	.navClose span:nth-child(1) {
		transform: translateY(0) rotate(45deg);
	}

	.navClose span:nth-child(3) {
		transform: translateY(0) rotate(-45deg);
	}

	.navClose span:nth-child(2) {
		opacity: 0;
	}

	.navList {
		display: block;
		li {
			display: block;
			text-align: left;
			padding: 0;
			margin: 0;
			a {
				padding: 0 .3rem;
				line-height: 44px;
				color: #333333;

				&:before {
					height: 1px;
					background-color: $mainColor;
					left: 0;
					width: 0;
				}
			}
		}

		.subNav {
			position: static;
			border-top: none;
			overflow: hidden;
			transition: all .5s;
			min-width: 0;
			transform: translateX(0);
			box-shadow: none;
			padding: 0 .5rem .2rem;
			>a {
				width: 100%;
				text-align: left;
				padding: 0;
				transition: all .3s;
				line-height: 36px;

				&:hover {
					background: none;
					color: #666;
				}
			}
		}
	}

	.navBg.active {
		opacity: .8;
		visibility: visible;
	}

	.navBox.active {
		right: 0;
	}
}

@media screen and (max-width:640px) {
	
}

@media screen and (max-width:460px) {
	
}

@media screen and (max-width:360px) {
	
}
</style>